import FilterBasicLegacyMultiSelection, {
  filterBasicLegacyMultiSelectionDesigns
} from './components/MultiSelection/index.js'
import FilterBasicLegacyMultiSelectionNested from './components/MultiSelectionNested/index.js'
import FilterBasicLegacySingleSelection, {
  FilterBasicLegacySingleSelectionItem,
  filterBasicLegacySingleSelectionItemDesigns
} from './components/SingleSelection/index.js'

export {
  FilterBasicLegacySingleSelection,
  FilterBasicLegacySingleSelectionItem,
  FilterBasicLegacyMultiSelection,
  FilterBasicLegacyMultiSelectionNested,
  filterBasicLegacySingleSelectionItemDesigns,
  filterBasicLegacyMultiSelectionDesigns
}

export default () => {
  throw new Error('Not mean to be used like this')
}
